/**
 * @file components/biz/listPage/Cards
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import React from 'react';
import {Loading} from 'acud';
import {TableLocale} from 'acud/lib/table/interface';
import _ from 'lodash';

import {DU_PREFIX} from '../../_common/constants';

const CLS_PREFIX = `${DU_PREFIX}-cards`;

export interface TableRowSelection {
    selectedRowKeys?: string[] | number[];
    onChange?: (selectedRowKeys: string[] | number[]) => void;
}

export interface CardsProps<T> {
    loading: boolean;
    rowKey: string; // tableData主键
    dataSource: T[];
    card: React.ComponentType<any>; // card组件
    rowSelection?: TableRowSelection;
    locale: TableLocale;
    onHandleAction: (config: any, payload: any) => void;
    onHandleTableCommand: (type: string, payload?: any) => void;
}

export default class Cards<T> extends React.Component<CardsProps<T>, any> {

    handleCheckboxChange = (evt: any, itemId: any) => {
        const rowSelection = this.props.rowSelection;
        if (rowSelection) {
            // 上次选择的数据
            const selectedRowKeys = rowSelection.selectedRowKeys as (string[] | number[]);
            const checked = evt.target.checked;
            // 最新选择的数据
            const newSelectedRowKeys = checked
                ? [...selectedRowKeys, itemId]
                : _.filter(selectedRowKeys, key => key !== itemId);

            rowSelection.onChange && rowSelection.onChange(newSelectedRowKeys);
        }
    };

    render() {
        const {
            dataSource,
            loading,
            locale,
            rowKey,
            card: Card,
            rowSelection,
            onHandleAction,
            onHandleTableCommand
        } = this.props;

        return (
            <div className={CLS_PREFIX}>
                <Loading loading={loading}>
                    {!loading && dataSource.length ? (
                        _.map(dataSource, (item: any) => (
                            <div className={`${CLS_PREFIX}-card`} key={item[rowKey]}>
                                <Card
                                    item={item}
                                    selectedRowKeys={rowSelection && rowSelection.selectedRowKeys}
                                    onHandleAction={onHandleAction}
                                    onHandleTableCommand={onHandleTableCommand}
                                    onCheckboxChange={this.handleCheckboxChange}
                                />
                            </div>
                        ))
                    ) : locale.emptyText}
                </Loading>
            </div>
        );
    }
}
